<template>
	<div class="page">
		<div class="page-title bg-white padding-lr flex justify-between align-center shadow-warp border-bottom">
			<div class="text-lg text-bold">
				<i class="el-icon-caret-right"></i>
				{{ $route.meta.title }}
			</div>
			<router-link to="add">
			<el-button type="success" round>
				<span class="el-icon-plus"></span>
				添加产品
			</el-button>
			</router-link>
		</div>
		<div class="page-main">
			<el-card class="box-card" :body-style="{ padding: '0px' }">
				<el-row>
					<el-col :span="4" class="border-right" style="margin-right: -1px;">
						<div class="flex justify-between align-center padding border-bottom">
							<div>
								<span class="el-icon-search"></span>
								<span class="text-bold margin-left-sm">产品分类</span>
							</div>
							<el-button size="small" type="success" @click="dialogVisibleAdd = true">
								<i class="el-icon-plus"></i>
								<span>添加</span>
							</el-button>
						</div>
						<div class="padding">
							<el-tree
								ref="deptTree"
								:data="categoryList"
								:expand-on-click-node="false"
								:props="{ label: 'name' }"
								:default-expand-all="true"
								:highlight-current="true"
								node-key="id"
								:indent="0"
								:draggable="true"
								@current-change="changeTreeCheck"
								class="tree-line tree-menu"
							>
								<div style="width: 100%;" slot-scope="{ node, data }">
									<div class="flex justify-between align-center">
										<div>
											<span>{{ data.name }}</span>
											<el-tag size="mini" type="info" class="margin-left-xs" v-if="data.stateflag == 0">已解散</el-tag>
										</div>
										<a class="cu-tag line-orange radius" style="line-height: 20px;" @click="modifyCategory($event, data)" v-if="data.id > 0">修改</a>
									</div>
								</div>
							</el-tree>
						</div>
					</el-col>
					<el-col :span="20" class="border-left">
						<el-form :inline="true" :model="formSearch" class="demo-form-inline padding-top-lg padding-lr-lg">
							<el-form-item label="名称"><el-input v-model="formSearch.data.name" clearable placeholder="模糊查找" style="width: 200px;"></el-input></el-form-item>
							<el-form-item label="状态">
								<el-select v-model="formSearch.data.state" clearable placeholder="状态" style="width: 120px;">
									<el-option label="全部" value=""></el-option>
									<el-option label="正常" value="1"></el-option>
									<el-option label="禁用" value="0"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item><el-button type="primary" @click="getInfoList">查询</el-button></el-form-item>
						</el-form>
						<div class="border-top">
							<el-table :data="tableData" style="width: 100%" stripe v-loading="loading" element-loading-text="加载中..." element-loading-spinner="el-icon-loading">
								<el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
								<el-table-column prop="name" align="center" label="名称"></el-table-column>
								<el-table-column prop="category" align="center" label="分组"></el-table-column>
								<el-table-column align="center" label="状态" width="120">
									<template slot-scope="scope">
										<el-switch
											v-model="scope.row.stateflag"
											:active-value="1"
											:inactive-value="0"
											active-color="#13ce66"
											@change="changeUserState(scope.row)"
										></el-switch>
									</template>
								</el-table-column>
								<el-table-column prop="logintimes" align="center" label="登陆次数" width="100"></el-table-column>
								<el-table-column prop="addtime" align="center" label="创建时间" width="180"></el-table-column>
								<el-table-column align="center" label="操作" width="120">
									<template slot-scope="scope">
										<el-button size="small" type="warning" @click="modifyUser(scope.row)">
											<span class="el-icon-edit"></span>
											修 改
										</el-button>
									</template>
								</el-table-column>
							</el-table>
							<div class="padding text-right">
								<el-pagination
									background
									@size-change="pageSizeChange"
									@current-change="pageChange"
									:current-page="formSearch.page"
									:page-sizes="[10, 20, 50, 100]"
									:page-size="20"
									layout="total, sizes, prev, pager, next, jumper"
									:total="total"
								></el-pagination>
							</div>
						</div>
					</el-col>
				</el-row>
			</el-card>
		</div>

		<!-- 添加分类 -->
		<el-dialog :show-close="false" append-to-body :visible.sync="dialogVisibleAdd" width="500px">
			<div slot="title" class="flex align-center justify-between">
				<div class="flex align-center">
					<span class="el-icon-folder-opened text-gray text-xxl"></span>
					<div class="margin-left-xs"><div class="text-bold">添加分类</div></div>
				</div>
				<el-link :underline="false" type="info" @click="dialogVisibleAdd = false"><i class="el-icon-close text-xxl"></i></el-link>
			</div>
			<div class="" v-loading="loadingAdd">
				<el-form :model="formAdd" ref="formAdd" label-suffix=":" label-width="100px">
					<el-form-item label="名称" prop="name" :rules="{ required: true, message: '请输入分类名称', trigger: 'blur' }">
						<el-input v-model="formAdd.name" placeholder="请输入分类名称" style="width: 220px;"></el-input>
					</el-form-item>
					<el-form-item label="状态"><el-switch v-model="formAdd.stateflag" :active-value="1" :inactive-value="0" active-color="#13ce66"></el-switch></el-form-item>
					<el-form-item label="上级分类" prop="parentid">
						<el-cascader
							v-model="formAdd.parentid"
							placeholder="为空则为顶级分类"
							clearable
							:options="categoryList"
							:props="{ emitPath: false, checkStrictly: true, value: 'id', label: 'name' }"
						></el-cascader>
					</el-form-item>
					<el-divider></el-divider>
					<el-form-item label="">
						<el-button type="primary" @click="formSubmitAdd">
							<i class="el-icon-s-promotion margin-right-xs"></i>
							提 交
						</el-button>
						<el-button @click="formAddInit">清 除</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>

		<!-- 修改分类信息 -->
		<el-dialog :show-close="false" append-to-body :visible.sync="dialogVisibleModify" width="500px">
			<div slot="title" class="flex align-center justify-between">
				<div class="flex align-center">
					<span class="el-icon-folder-opened text-gray text-xxl"></span>
					<div class="margin-left-xs"><div class="text-bold">修改分类信息</div></div>
				</div>
				<el-link :underline="false" type="info" @click="dialogVisibleModify = false"><i class="el-icon-close text-xxl"></i></el-link>
			</div>
			<div class="padding-top-lg" v-loading="loadingModify">
				<el-form :model="formModify" ref="formModify" label-suffix=":" label-width="100px">
					<el-form-item label="名称" prop="name" :rules="{ required: true, message: '请输入分类名称', trigger: 'blur' }">
						<el-input v-model="formModify.name" placeholder="请输入分类名称" style="width: 220px;"></el-input>
					</el-form-item>
					<el-form-item label="状态"><el-switch v-model="formModify.stateflag" :active-value="1" :inactive-value="0" active-color="#13ce66"></el-switch></el-form-item>
					<el-form-item label="上级分类" prop="parentid">
						<el-cascader
							v-model="formModify.parentid"
							placeholder="为空则为顶级分类"
							clearable
							:options="categoryList"
							:props="{ emitPath: false, checkStrictly: true, value: 'id', label: 'name' }"
						></el-cascader>
					</el-form-item>
					<el-divider></el-divider>
					<el-form-item label="">
						<el-button type="primary" @click="formSubmitUserModify">
							<i class="el-icon-s-promotion margin-right-xs"></i>
							提 交
						</el-button>
						<el-button @click="dialogVisibleModify = false">取 消</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			categoryList: [{ id: '0', name: '顶级分类' }, { id: '1', name: '顶级分类2' }],
			formSearch: {
				page: 1,
				size: 20,
				data: {
					category:0
				}
			},
			total: 0,
			loading: false,
			tableData: [],
			dialogVisibleAdd: false,
			loadingAdd: false,
			formAdd: {
				name: '',
				parentid: 0,
				stateflag: 1
			},
			dialogVisibleModify: false,
			loadingModify: false,
			formModify: {}
		};
	},
	beforecreate: function() {},
	created: function() {
		this.getCategoryList();
		this.getInfoList();
	},
	mounted: function() {},
	updated: function() {},
	methods: {
		getCategoryList() {
			this.loading = true;
			this.$http.post('/server/index.php?m=manager/product&a=getCategoryList', {}).then(
				res => {
					this.loading = false;
					if (res.result == 'ok') {
						this.categoryList = res.data;
					} else {
						this.$message.error(res.msg);
					}
				},
				err => {
					this.loading = false;
					if (err) {
						this.$alert('网络错误，指定的服务无法访问。', {
							title: '系统错误',
							type: 'error'
						});
					}
				}
			);
		},
		changeTreeCheck(e) {
			this.formSearch.data.category=e.id;
			this.getInfoList();
		},
		getInfoList() {
			this.loading = true;
			this.$http.post('/server/index.php?m=manager/product&a=getInfoList', this.formSearch).then(
				res => {
					this.loading = false;
					if (res.result == 'ok') {
						this.total = res.data.total;
						this.tableData = res.data.infos;
					} else {
						this.$message.error(res.msg);
					}
				},
				err => {
					this.loading = false;
					if (err) {
						this.$alert('网络错误，指定的服务无法访问。', {
							title: '系统错误',
							type: 'error'
						});
					}
				}
			);
		},
		pageChange(page) {
			this.formSearch.page = page;
			this.getInfoList();
		},
		pageSizeChange(size) {
			this.formSearch.size = size;
			this.getInfoList();
		},
		changeEmployee(val) {
			console.log(val);
			this.formAdd.employee = Object.assign({}, val.data);
		},
		formAddInit() {
			this.formAdd = Object.assign(
				{},
				{
					name: '',
					parentid: 0,
					stateflag: 1
				}
			);
		},
		changeParentId(e) {
			console.log(e);
			this.formAdd.parentid = e;
		},
		formSubmitAdd() {
			console.log(this.formAdd);
			this.$refs['formAdd'].validate(valid => {
				if (valid) {
					this.loadingAdd = true;
					this.$http.post('/server/index.php?m=manager/product&a=addCategory', this.formAdd).then(
						res => {
							this.loadingAdd = false;
							if (res.result == 'ok') {
								this.$message('添加成功！', {
									type: 'success'
								});
								this.dialogVisibleAdd = false;
								this.getCategoryList();
							} else {
								this.$alert(res.msg, {
									title: '操作错误',
									type: 'error'
								});
							}
						},
						err => {
							this.loadingAdd = false;
							if (err) {
								this.$alert('网络错误，指定的服务无法访问。', {
									title: '系统错误',
									type: 'error'
								});
							}
						}
					);
				} else {
					console.log('error submit!!');
				}
			});
		},
		modifyCategory(e, data) {
			console.log(data);
			e.stopPropagation();
			this.dialogVisibleModify = true;
			this.formModify = Object.assign({}, data);
			return false;
		},
		formSubmitUserModify() {
			this.$refs['formModify'].validate(valid => {
				if (valid) {
					this.loadingModify = true;
					this.$http.post('/server/index.php?m=manager/product&a=modifyCategory', this.formModify).then(
						res => {
							this.loadingModify = false;
							if (res.result == 'ok') {
								this.$message('修改成功！', {
									type: 'success'
								});
								this.dialogVisibleModify = false;
								this.getCategoryList();
							} else {
								this.$alert(res.msg, {
									title: '操作错误',
									type: 'error'
								});
							}
						},
						err => {
							this.loadingModify = false;
							if (err) {
								this.$alert('网络错误，指定的服务无法访问。', {
									title: '系统错误',
									type: 'error'
								});
							}
						}
					);
				} else {
					console.log('error submit!!');
				}
			});
		}
	}
};
</script>

<style>
.tree-line .el-tree-node__content {
	height: 40px;
	line-height: 40px;
}
.tree-line .el-tree-node {
	position: relative;
	padding-left: 10px;
}
.tree-line .el-tree-node__children {
	padding-left: 10px;
}
.tree-line .el-tree-node::before {
	content: '';
	height: 100%;
	width: 1px;
	position: absolute;
	left: -3px;
	top: -21px;
	border-width: 1px;
	border-left: 1px dashed #ddd;
}
.tree-line .el-tree-node:last-child::before {
	height: 38px;
}
.tree-line .el-tree-node::after {
	content: '';
	width: 24px;
	height: 20px;
	position: absolute;
	left: -3px;
	top: 19px;
	border-width: 1px;
	border-top: 1px dashed #ddd;
}
.tree-line > .el-tree-node::after {
	border-top: none;
}
.tree-line > .el-tree-node::before {
	border-left: none;
}
.tree-line .el-tree-node__expand-icon {
	font-size: 10px;
}
.tree-line .el-tree-node__expand-icon.is-leaf {
	color: transparent;
}
.tree-menu.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
	font-weight: bold;
	color: #000;
}
.tree-line .el-icon-caret-right:before {
	color: #ccc;
}
</style>
